<div class="sidebar-title">
  <i nz-icon [nzType]="'icons:' + titleicon()" class="sensor-icon svg-icon"></i>
  <h2>{{ title() }}</h2>
</div>
<ng-content></ng-content>
<app-search-filter
  (searchFilterChanged)="onSearchFilterChanged()"
  [sidebar]="true"
  [onlysearch]="!showFilter()"
  [plantsFilter]="plantsFilter()"
  [notificationsFilter]="notificationsFilter()"
></app-search-filter>

@if (showList() && cfg.appName === "ia") {
  @if (Loading()) {
    <app-spinner [black]="true"></app-spinner>
  }

  @if (!!plant() && !Loading()) {
    @for (building of plant()?.children; track building.objectID) {
      <div class="area-wrapper detail-bold">
        <app-rename-card-header
          [sidebar]="true"
          [location]="building"
          class="panel"
        ></app-rename-card-header>

        <app-collapse-sidebar
          [location]="building"
          [selectedAssetId]="selectedAssetId()"
          [selectedSensorId]="selectedSensorId()"
        ></app-collapse-sidebar>
      </div>
    }
  }
}

@if (showList() && cfg.appName === "em") {
  <div style="padding-left: 8px">
    @if (Loading()) {
      <app-spinner [black]="true"></app-spinner>
    }
    @if (!Loading()) {
      <ng-container>
        @for (building of Buildings(); track $index) {
          <ng-container>
            <span
              class="area-subtitle building-subtitle"
              [class.first-building-subtitle]="building === Buildings()[0]"
              >{{ i18n.parse(building.layerName) }}
            </span>
            <span
              class="area-title"
              [class.clickable]="isLocationClickable(building)"
              (click)="navToLocation(building)"
              >{{ i18n.parse(building.objectName) }} ({{
                building.Assets.length
              }})</span
            >
            @for (
              equipment of sortAssociatedEquipment(
                building.AssociatedEquipments
              );
              track $index
            ) {
              <div class="area-wrapper detail-bold">
                @if (equipment.curLayer !== "d") {
                  <ng-container>
                    <span class="area-subtitle">{{
                      i18n.parse(equipment.layerName)
                    }}</span>
                    <span
                      class="assoc-eq-title"
                      [class.clickable]="isLocationClickable(equipment)"
                      (click)="navToLocation(equipment)"
                      >{{ i18n.parse(equipment.objectName) }}</span
                    >
                  </ng-container>
                }
                <div class="area-inner-wrapper">
                  @for (eqasset of equipment.children; track $index) {
                    <ng-container>
                      @switch ($any(cfg.appName)) {
                        @case ("em") {
                          @if (
                            eqasset.isConnected &&
                            (!eqasset.isArchived ||
                              eqasset.objectID === asset()?.objectID)
                          ) {
                            <div
                              class="area-asset"
                              [class.disconnected]="!eqasset.isConnected"
                              [class.activeAsset]="
                                eqasset.objectID === asset()?.objectID
                              "
                              [class.activeCritAsset]="
                                eqasset.objectID === asset()?.objectID &&
                                eqasset.critical
                              "
                              [class.activeWarningAsset]="
                                eqasset.objectID === asset()?.objectID &&
                                eqasset.warning
                              "
                              [class.inactiveAsset]="
                                eqasset.objectID === asset()?.objectID &&
                                eqasset.inactive
                              "
                              [routerLink]="['/asset', eqasset.objectID, -1]"
                              (click)="eqasset.isConnected || onClick()"
                            >
                              <div class="area-inner-asset-wrapper">
                                <span class="asset-border"></span>
                                <div class="area-inner-inner-asset-wrapper">
                                  @if (
                                    eqasset.isConnected &&
                                    !eqasset.critical &&
                                    !eqasset.warning &&
                                    !eqasset.inactive
                                  ) {
                                    <i
                                      nz-icon
                                      nzType="icons:circle"
                                      class="sensor-icon svg-icon mini-icon fillgreen circle-icon"
                                    ></i>
                                  }

                                  @if (!eqasset.isConnected) {
                                    <i
                                      nz-icon
                                      nzType="icons:disconnected"
                                      class="sensor-icon svg-icon mini-icon fillgrey"
                                    ></i>
                                  }

                                  @if (
                                    eqasset.isConnected &&
                                    eqasset.warning &&
                                    !eqasset.inactive
                                  ) {
                                    <i
                                      nz-icon
                                      nzType="icons:status-exclamation-octagon"
                                      class="sensor-icon svg-icon mini-icon fillorange"
                                    ></i>
                                  }

                                  @if (
                                    eqasset.isConnected &&
                                    eqasset.critical &&
                                    !eqasset.inactive
                                  ) {
                                    <i
                                      nz-icon
                                      nzType="icons:status-exclamation-triangle"
                                      class="sensor-icon svg-icon mini-icon fillred"
                                    ></i>
                                  }

                                  @if (
                                    eqasset.isConnected && eqasset.inactive
                                  ) {
                                    <i
                                      nz-icon
                                      nzType="icons:cross-circle"
                                      class="sensor-icon svg-icon mini-icon fillblackcoral"
                                    ></i>
                                  }

                                  <!-- nzTooltipTitle={{eqasset.objectName}}  -->
                                  <span
                                    class="assetname"
                                    [class.grey-text]="
                                      !eqasset.isConnected || eqasset.inactive
                                    "
                                    [class.red-text]="
                                      !!eqasset.isConnected &&
                                      eqasset.critical &&
                                      !eqasset.inactive
                                    "
                                    [class.orange-text]="
                                      !!eqasset.isConnected &&
                                      eqasset.warning &&
                                      !eqasset.inactive
                                    "
                                    nzTooltipPlacement="bottomLeft"
                                    nzTooltipColor="#5F6973"
                                    nz-tooltip
                                    >{{ i18n.parse(eqasset.objectName) }}</span
                                  >
                                </div>
                              </div>
                            </div>
                          }
                        }
                        @case ("ia") {
                          @if (
                            !eqasset.isArchived ||
                            eqasset.objectID === asset()?.objectID
                          ) {
                            <div
                              class="area-asset"
                              [class.disconnected]="!eqasset.isConnected"
                              [class.activeAsset]="
                                eqasset.objectID === asset()?.objectID
                              "
                              [class.activeCritAsset]="
                                eqasset.objectID === asset()?.objectID &&
                                eqasset.critical
                              "
                              [class.activeWarningAsset]="
                                eqasset.objectID === asset()?.objectID &&
                                eqasset.warning
                              "
                              [class.inactiveAsset]="
                                eqasset.objectID === asset()?.objectID &&
                                eqasset.inactive
                              "
                              [routerLink]="['/asset', eqasset.objectID, -1]"
                              (click)="eqasset.isConnected || onClick()"
                            >
                              <div class="area-inner-asset-wrapper">
                                <span class="asset-border"></span>
                                <div class="area-inner-inner-asset-wrapper">
                                  @if (
                                    eqasset.isConnected &&
                                    !eqasset.critical &&
                                    !eqasset.warning &&
                                    !eqasset.inactive
                                  ) {
                                    <i
                                      nz-icon
                                      nzType="icons:circle"
                                      class="sensor-icon svg-icon mini-icon fillgreen circle-icon"
                                    ></i>
                                  }

                                  @if (!eqasset.isConnected) {
                                    <i
                                      nz-icon
                                      nzType="icons:disconnected"
                                      class="sensor-icon svg-icon mini-icon fillgrey"
                                    ></i>
                                  }

                                  @if (
                                    eqasset.isConnected &&
                                    eqasset.warning &&
                                    !eqasset.inactive
                                  ) {
                                    <i
                                      nz-icon
                                      nzType="icons:status-exclamation-octagon"
                                      class="sensor-icon svg-icon mini-icon fillorange"
                                    ></i>
                                  }

                                  @if (
                                    eqasset.isConnected &&
                                    eqasset.critical &&
                                    !eqasset.inactive
                                  ) {
                                    <i
                                      nz-icon
                                      nzType="icons:status-exclamation-triangle"
                                      class="sensor-icon svg-icon mini-icon fillred"
                                    ></i>
                                  }

                                  @if (
                                    eqasset.isConnected && eqasset.inactive
                                  ) {
                                    <i
                                      nz-icon
                                      nzType="icons:cross-circle"
                                      class="sensor-icon svg-icon mini-icon fillblackcoral"
                                    ></i>
                                  }

                                  <!-- nzTooltipTitle={{eqasset.objectName}}  -->
                                  <span
                                    class="assetname"
                                    [class.grey-text]="
                                      !eqasset.isConnected || eqasset.inactive
                                    "
                                    [class.red-text]="
                                      !!eqasset.isConnected &&
                                      eqasset.critical &&
                                      !eqasset.inactive
                                    "
                                    [class.orange-text]="
                                      !!eqasset.isConnected &&
                                      eqasset.warning &&
                                      !eqasset.inactive
                                    "
                                    nzTooltipPlacement="bottomLeft"
                                    nzTooltipColor="#5F6973"
                                    nz-tooltip
                                    >{{ i18n.parse(eqasset.objectName) }}</span
                                  >
                                </div>
                              </div>
                            </div>
                          }
                        }
                      }

                      @if (eqasset.objectID === asset()?.objectID) {
                        <div class="area-asset-telemetry">
                          @for (sensor of asset()?.sensors; track $index) {
                            <ng-container>
                              <div
                                class="telemetry-inner-wrapper"
                                [class.activeTelemetry]="
                                  sensorID() === sensor.sensorID
                                "
                                [class.activeCritTelemetry]="
                                  sensorID() === sensor.sensorID &&
                                  sensor.Critical
                                "
                                [class.activeInactiTelemetry]="
                                  sensorID() === sensor.sensorID &&
                                  sensor.Inactive
                                "
                                [class.activeWarningTelemetry]="
                                  sensorID() === sensor.sensorID &&
                                  sensor.Warning
                                "
                                (click)="
                                  toSensor(eqasset.objectID, sensor.sensorID)
                                "
                              >
                                <span class="telemetry-border"></span>
                                <span
                                  class="telemetry-name"
                                  [class.grey-text]="sensor.Inactive"
                                  [class.orange-text]="sensor.Warning"
                                  [class.red-text]="sensor.Critical"
                                  >{{ sensor.sensorDisplayLabel }}</span
                                >
                              </div>
                            </ng-container>
                          }

                          @if (asset()?.temperature) {
                            <ng-container>
                              @for (
                                eqtelemetry of [asset()?.temperature];
                                track $index
                              ) {
                                <ng-container>
                                  <div
                                    class="telemetry-inner-wrapper"
                                    [class.activeTelemetry]="
                                      !!telemetry &&
                                      telemetry()?.sensorID ===
                                        eqtelemetry.sensorID &&
                                      telemetry()?.measurementTypeID ===
                                        eqtelemetry.measurementTypeID
                                    "
                                    [class.activeCritTelemetry]="
                                      !!telemetry &&
                                      telemetry()?.sensorID ===
                                        eqtelemetry.sensorID &&
                                      telemetry()?.measurementTypeID ===
                                        eqtelemetry.measurementTypeID &&
                                      eqtelemetry.critical
                                    "
                                    [class.activeWarningTelemetry]="
                                      !!telemetry &&
                                      telemetry()?.sensorID ===
                                        eqtelemetry.sensorID &&
                                      telemetry()?.measurementTypeID ===
                                        eqtelemetry.measurementTypeID &&
                                      eqtelemetry.warning
                                    "
                                    [class.activeInactiTelemetry]="
                                      !!telemetry &&
                                      telemetry()?.sensorID ===
                                        eqtelemetry.sensorID &&
                                      telemetry()?.measurementTypeID ===
                                        eqtelemetry.measurementTypeID &&
                                      eqtelemetry.inactive
                                    "
                                    (click)="
                                      toSensorValue(
                                        eqasset.objectID,
                                        eqtelemetry.sensor.sensorID,
                                        eqtelemetry.measurementTypeID
                                      )
                                    "
                                  >
                                    <span class="telemetry-border"></span>
                                    <span
                                      class="telemetry-name"
                                      [class.red-text]="eqtelemetry.critical"
                                      [class.grey-text]="eqtelemetry.inactive"
                                      [class.orange-text]="eqtelemetry.warning"
                                      >{{
                                        i18n.langString(
                                          "temperature_of_the_edge_device"
                                        )
                                      }}</span
                                    >
                                  </div>
                                </ng-container>
                              }
                            </ng-container>
                          }

                          @if (
                            asset() &&
                            asset().health &&
                            asset().health.length > 0
                          ) {
                            <div
                              class="telemetry-inner-wrapper"
                              [class.activeTelemetry]="sensorHealthPage()"
                              [class.activeCritTelemetry]="
                                sensorHealthPage() &&
                                isSensorHealthCrit(asset())
                              "
                              [class.activeWarningTelemetry]="
                                sensorHealthPage() &&
                                isSensorHealthWarning(asset())
                              "
                              [class.activeInactiTelemetry]="
                                sensorHealthPage() &&
                                isSensorHealthInacti(asset())
                              "
                              (click)="toSensorHealth(eqasset.objectID)"
                            >
                              <span class="telemetry-border"></span>
                              <span
                                class="telemetry-name"
                                [class.red-text]="isSensorHealthCrit(asset())"
                                [class.grey-text]="
                                  isSensorHealthInacti(asset())
                                "
                                >{{ i18n.langString("edge_device_health") }}</span
                              >
                            </div>
                          }
                        </div>
                      }
                    </ng-container>
                  }
                </div>
              </div>
            }
          </ng-container>
        }
      </ng-container>
    }
  </div>
}
